import * as S from './styles';
import LogoMini from '../../assets/images/logo-mini.svg';

type Props = {
  linkDownload: string;
};

export const Footer = ({ linkDownload }: Props) => {
  const handleDownloadApp = () => window.open(linkDownload, '__blank');

  return (
    <S.Container>
      <S.WrapperInfo data-testid="container-text">
        Feito com ❤️ por <img src={LogoMini.src} alt="Get In" />
      </S.WrapperInfo>
      <S.Button type="button" onClick={handleDownloadApp}>
        Baixe o app
      </S.Button>
    </S.Container>
  );
};
